import { useAppSelector } from '@hooks/redux.hooks';
import { hasSensorRoleFromActiveProfile } from '@redux/authent/authent.selectors';

import { ActionEnum } from '@/types/commons/commons.types';
import { SensorFamilyEnum } from '@/types/sensor/sensor.types';

export interface UseAutomatonRights {
  hasRolePeriSensorCommand: boolean;
  hasRoleSensorMaintenance: boolean;
  hasRoleRepulsionCommand: boolean;
  hasRoleDetectionCommand: boolean;
}

export const useAutomatonRight: () => UseAutomatonRights = () => {
  const hasRolePeriSensorCommand = useAppSelector((state) =>
    hasSensorRoleFromActiveProfile(state, { action: ActionEnum.COMMAND, sensorFamily: SensorFamilyEnum.AUTOMATON }),
  );
  const hasRoleSensorMaintenance = useAppSelector((state) =>
    hasSensorRoleFromActiveProfile(state, { action: ActionEnum.MAINTAIN, sensorFamily: SensorFamilyEnum.AUTOMATON }),
  );
  const hasRoleRepulsionCommand = useAppSelector((state) =>
    hasSensorRoleFromActiveProfile(state, {
      action: ActionEnum.ACTIVATE_REPULSION,
      sensorFamily: SensorFamilyEnum.AUTOMATON,
    }),
  );
  const hasRoleDetectionCommand = useAppSelector((state) =>
    hasSensorRoleFromActiveProfile(state, {
      action: ActionEnum.DEACTIVATE_REPULSION,
      sensorFamily: SensorFamilyEnum.AUTOMATON,
    }),
  );

  return {
    hasRolePeriSensorCommand,
    hasRoleSensorMaintenance,
    hasRoleRepulsionCommand,
    hasRoleDetectionCommand,
  };
};
